import { Link } from '@tanstack/react-router';
import styles from '../Home.module.css';
import { useIssues } from '@hooks/use-issue';
import { useGetLatestIssue } from '../Home.hooks';

export default function LatestIssue() {
	const { isLoading, issue } = useGetLatestIssue();

	if (!issue) return <section className={styles['latest']} />;
	const { slug, id } = issue;
	return (
		<section className={`${styles['latest']} p-4`}>
			{isLoading ? (
				<div>Loading</div>
			) : (
				<Link
					to="/preview/$id"
					params={{ id: slug ? slug : id }}
					className="flex justify-center items-center"
				>
					<figure>
						<img src={issue.cover} className="rounded-2xl" />
						<figcaption className="mt-4">{issue.name}</figcaption>
					</figure>
				</Link>
			)}
		</section>
	);
}
